var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"button-setting",class:_vm.data.position && 'button-more-setting',style:({
      position: _vm.data.position,
      bottom: (_vm.btnBottom ) / 16 + 'rem',
      'margin-bottom': (_vm.data.marginBottom ) / 16 + 'rem',
      fontSize: (_vm.data.fontSize ) / 16 + 'rem',
      fontWeight: _vm.data.fontWeight,
      color: _vm.data.btnFontColor,
      textAlign: _vm.data.textAlign,
      fontFamily: _vm.data.family,
      width: (_vm.data.btnWidth ) / 16 + 'rem',
      height: (_vm.data.btnHeight ) / 16 + 'rem',
      borderRadius: (_vm.data.btnRadius ) / 16 + 'rem',
      lineHeight: (_vm.data.btnHeight ) / 16 + 'rem',
      'background-color': _vm.data.btnColor,
      'background-image': 'url(' + _vm.data.btnImage + ')'
    }),on:{"click":function($event){return _vm.handleClick(_vm.data.btnEventStatus)}}},[(_vm.data.btnIcon)?_c('img',{staticClass:"btnIcon",attrs:{"src":_vm.data.btnIcon}}):_vm._e(),_c('span',{staticClass:"btnText"},[_vm._v(" "+_vm._s(_vm.data.btnText))])]),(_vm.isIphoneX && _vm.data.position && _vm.data.bottomIphoneX)?_c('div',{style:({
    position: _vm.data.position,
    bottom: 0,
    width: (_vm.data.btnWidth ) / 16 + 'rem',
    height: (_vm.data.bottomIphoneX ) / 16 + 'rem',
    'background-color': _vm.data.btnColor,
  })}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }